export default "__VITE_ASSET__gd3Qs_0V__"